import config from '~/config';
import { getELDToken } from './cookie';

const headers = {
  token: getELDToken()
}
export function getELDUserInfo() {
  return window.fetch(`${config.apiELD}/user`, {
    headers,
    method: 'get',
    mode: 'cors'
  }).then(res => res.json().then(data => Promise.resolve({data, status: res.status})));
}


// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/api.js